import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-product5",
  "use": "icon-product5-usage",
  "viewBox": "0 0 68 55",
  "content": "<symbol viewBox=\"0 0 68 55\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-product5\">\n<path d=\"M10.8467 25.246V0.834961H57.3312V25.246\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M66.7988 32.3589H57.3316L60.671 54.1652H58.3L53.2909 32.3589H14.8878L9.87867 54.1652H7.50769L10.8471 32.3589H1.37988V29.2866H66.7988V32.3589Z\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol